import { useContext, useState } from "react";
import { Box, Container, styled, Typography } from "@mui/material";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import { Button } from "@mui/material";
import imageOnboarding from "../../../assets/images/onboarding.png";
import { RetailContext } from "../../../contexts/retail/retailMain.context";
import { useRouter } from "../../../utils/hooks/useRouter";
import { firebaseAndKvaLog } from "../../../services/analytics/analytic.service";
import {
  IconActiveNext,
  IconCart,
  IconHome,
  IconList,
  IconPlayVideo,
  IconSearch,
} from "../../Static/Icons/Icon";
import ModalVideoIntro from "../../Modal/Retail/ModalVideoIntro";
import { updateSyncStatusOnboard } from "../../../services/api/retail/websiteStatusApi";

const TitleHighlight = styled("span")({
  color: "#0D5DF0",
});

const Profit = styled("div")({
  background: "#F2FBFF",
  borderRadius: "12px",
  padding: "8px 12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  gap: "8px",
  width: "100%",
  marginTop: "8px",
});
const TextProfit = styled("div")({
  "> div:nth-of-type(1)": {
    color: "#001C43",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "140%",
    textAlign: "left",
  },
  "> div:nth-of-type(2)": {
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "140%",
    textAlign: "left",
  },
});
export function ItemProfit({
  icon,
  title,
  profitText,
  profitColor,
}: {
  icon: any;
  title: string;
  profitText: string;
  profitColor: string;
}) {
  return (
    <Profit>
      {icon}
      <TextProfit>
        <div>{title}</div>
        <div style={{ color: `${profitColor}` }}>{profitText}</div>
      </TextProfit>
    </Profit>
  );
}

export default function Onboarding() {
  const { handActive } = useContext(RetailContext);
  const router = useRouter();
  const [isOpenVideo, setIsOpenVideo] = useState(false);

  const handOpenVideoAdv = () => {
    const auth_code = router.query.code?.toString();
    const jwtDecode: { [key: string]: any } = auth_code
      ? jwt_decode(auth_code)
      : {};
    firebaseAndKvaLog(router.query.platform, "kvapp_mk_setup_video", {
      id: jwtDecode.sub || null,
      merchantId: jwtDecode.kvrid || null,
      merchantCode: jwtDecode.kvrcode || null,
      userName: jwtDecode.preferred_username || null,
    });
    setIsOpenVideo(true);
  };

  const handActiveWebsite = () => {
    const auth_code = router.query.code?.toString();
    const jwtDecode: { [key: string]: any } = auth_code
      ? jwt_decode(auth_code)
      : {};

    if (auth_code) {
      Cookies.set("auth_code", auth_code);
    }

    firebaseAndKvaLog(router.query.platform, "kvapp_mk_setup_enable", {
      id: jwtDecode.sub || null,
      merchantId: jwtDecode.kvrid || null,
      merchantCode: jwtDecode.kvrcode || null,
      userName: jwtDecode.preferred_username || null,
    });
    updateSyncStatusOnboard({ is_onboarding: true, platform: "retail" }).then(
      () => {
        const code = router.query.code ?? "";
        const url = `${process.env.REACT_APP_ADMIN_URL}/retail/m/preview?code=${code}`;
        window.location.replace(url);
      }
    );
    // handActive && handActive();
  };
  // const goBackSuperApp = () => {
  //   (window as any).goBackSuperApp("retail");
  // };

  return (
    <>
      <Container
        sx={{
          padding: "0 0 200px 0 !important",
          minHeight: "100vh",
          maxWidth: "414px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            padding: "20px 12px 0 12px",
          }}
        >
          <Typography
            variant="h2"
            color="text.secondary"
            sx={{
              color: "#111315",
              fontWeight: 600,
              fontSize: "28px",
              lineHeight: "34px",
              fontFamily: "Inter,sans-serif",
              textAlign: "center",
            }}
          >
            Tạo website
            <br /> bán hàng online <TitleHighlight>Miễn Phí</TitleHighlight>
          </Typography>
          <Box
            sx={{
              mt: "140px",
              width: "100%",
              padding: "100px 24px 24px 24px",
              background: "linear-gradient(180deg, #EDF9FF 0%, #ADE2FF 100%)",
              position: "relative",
              borderRadius: "20px",
            }}
          >
            <ItemProfit
              icon={<IconCart />}
              title={"Cửa hàng online"}
              profitColor={"#28B44F"}
              profitText={"Miễn phí 100%"}
            ></ItemProfit>

            <ItemProfit
              icon={<IconHome />}
              title={"Giao diện cửa hàng"}
              profitColor={"#0D5DF0"}
              profitText={"Đa dạng, đẹp mắt"}
            ></ItemProfit>

            <ItemProfit
              icon={<IconList />}
              title={"Lên đơn bán hàng"}
              profitColor={"#0D5DF0"}
              profitText={"Hiệu quả, tăng doanh thu"}
            ></ItemProfit>

            <ItemProfit
              icon={<IconSearch />}
              title={"Dễ dàng bán hàng trên"}
              profitColor={"#0D5DF0"}
              profitText={"Các kênh online"}
            ></ItemProfit>
            <div>
              <img
                src={imageOnboarding}
                width={257}
                style={{
                  position: "absolute",
                  top: "-120px",
                  left: "0",
                  right: "0",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </div>
          </Box>
        </Box>
      </Container>
      <Container
        className="fix-bottom"
        maxWidth="md"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "8px 12px",
          backgroundColor: "#fff",
          zIndex: 1,
          display: "flex",
          gap: "8px",
        }}
      >
        <Button
          size="large"
          variant="contained"
          onClick={handOpenVideoAdv}
          sx={{
            boxShadow: "none",
            padding: "14px 12px",
            borderRadius: "12px",
            border: "1px solid #0070F4",
            color: "#0070F4",
            background: "white",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "20px",
            fontFamily: "Inter,sans-serif",
            "&:hover,&:focus": {
              boxShadow: "none",
            },
            display: "flex",
            gap: "4px",
            "> div:nth-of-type(2)": {
              display: "flex",
              alignItems: "center",
            },
            width: "50%",
          }}
        >
          <div>Video giới thiệu</div>
          <div>
            <IconPlayVideo />
          </div>
        </Button>
        <Button
          size="large"
          variant="contained"
          onClick={handActiveWebsite}
          sx={{
            boxShadow: "none",
            padding: "14px 0",
            borderRadius: "12px",
            background: "#28A745",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "20px",
            fontFamily: "Inter,sans-serif",
            "&:hover,&:focus": {
              boxShadow: "none",
              backgroundColor: "#28A745",
            },
            display: "flex",
            gap: "4px",
            "> div:nth-of-type(2)": {
              display: "flex",
              alignItems: "center",
            },
            width: "50%",
          }}
        >
          <div>Mở cửa hàng ngay</div>
          <div>
            <IconActiveNext />
          </div>
        </Button>
      </Container>
      <ModalVideoIntro
        open={isOpenVideo}
        handCancel={() => setIsOpenVideo(false)}
      />
    </>
  );
}
